import { ComponentProps } from 'react';
import clsx from 'clsx';
import IconButton from 'components/IconButton';
import EyeClosedImg from 'assets/common/eye-closed.svg?react';
import EyeOpenImg from 'assets/common/eye-open.svg?react';

type Props = Omit<ComponentProps<typeof IconButton>, 'label' | 'children'> & {
  revealed: boolean;
  tooltip: string;
};

// One button for both states so keyboard focus survives the toggle.
// `className` sizes the icon; antd Input.Password clones its own class and handlers onto this root.
function RevealToggle({ revealed, tooltip, className, ...rest }: Props) {
  const Eye = revealed ? EyeClosedImg : EyeOpenImg;
  const label = `${revealed ? 'Hide' : 'Reveal'} ${tooltip}`;

  return (
    <IconButton label={label} {...rest}>
      <Eye
        aria-hidden
        focusable={false}
        className={clsx('cursorPointer', className)}
      />
    </IconButton>
  );
}

export default RevealToggle;
